module.exports = {"pt-BR":{"components":{"lot-group-item-overlay":{"title":"Detalhes do item"}}}}